import useNavigateWithQuery from "features/shared/hooks/navigation/useNavigateWithQuery";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { DocProcessingStatus } from "models/doc-processing-status";
import { useAppStore } from "store/store";
import useDocumentImagesUpload, {
  base64ToFile,
} from "features/shared/hooks/useDocumentImagesUpload";
import { PaxCheckDocumentProvisionMethod } from "api/models";
import useDemoScenario from "features/shared/hooks/demo/useDemoScenario";

const useSubmitFiles = (
  itemType: string,
  files: File[],
  processingMayTakeLong: boolean | null,
  additionalPaxSessionIds?: string[],
  pageIndexToProcess?: number
) => {
  const navigate = useNavigateWithQuery();
  const uploadFiles = useDocumentImagesUpload(
    PaxCheckDocumentProvisionMethod.UPLOAD
  );

  const [searchParams] = useSearchParams();
  const forceDocumentType = searchParams.get("forceDocumentType") ?? undefined;
  const demoScenario = useDemoScenario(forceDocumentType ?? itemType);

  return useCallback(async () => {
    const filesToUpload =
      demoScenario !== undefined
        ? [
            base64ToFile(
              demoScenario.fileContentBase64,
              demoScenario.fileName,
              "image/jpeg"
            ),
          ]
        : files;

    useAppStore.getState().setProcessedFileName(null);
    useAppStore.getState().setProcessingMayTakeLong(processingMayTakeLong);
    navigate("../processing");
    useAppStore
      .getState()
      .setProcessingStatus(DocProcessingStatus.InProgress, null);
    uploadFiles(filesToUpload, additionalPaxSessionIds, pageIndexToProcess);
  }, [
    navigate,
    uploadFiles,
    files,
    additionalPaxSessionIds,
    demoScenario,
    pageIndexToProcess,
    processingMayTakeLong,
  ]);
};

export default useSubmitFiles;
